import { createSlice } from '@reduxjs/toolkit';

// 2ECOMP: Limite de eventos mantidos em memória
const MAX_EVENTS = 50;

const { reducer, actions } = createSlice({
  name: 'events',
  initialState: {
    // 2ECOMP: Estrutura normalizada para O(1) lookup
    // items: array ordenado (mais recentes primeiro) - compatível com código existente
    // byId: objeto para lookup O(1) por id
    items: [],
    byId: {},
  },
  reducers: {
    // 2ECOMP OPTIMIZED: Adiciona eventos mantendo ordem e lookup O(1)
    add(state, action) {
      const newEvents = action.payload;

      // Adiciona novos eventos ao início (mais recentes primeiro)
      newEvents.forEach((event) => {
        // Evita duplicatas
        if (!state.byId[event.id]) {
          state.items.unshift(event);
          state.byId[event.id] = event;
        }
      });

      // Remove eventos antigos se exceder limite
      while (state.items.length > MAX_EVENTS) {
        const removed = state.items.pop();
        if (removed) {
          delete state.byId[removed.id];
        }
      }
    },
    // 2ECOMP OPTIMIZED: Delete O(1) lookup + O(n) filter (inevitável para array ordenado)
    delete(state, action) {
      const eventId = action.payload.id;
      if (state.byId[eventId]) {
        delete state.byId[eventId];
        state.items = state.items.filter((item) => item.id !== eventId);
      }
    },
    deleteAll(state) {
      state.items = [];
      state.byId = {};
    },
  },
});

export { actions as eventsActions };
export { reducer as eventsReducer };
